<footer class="app-footer">
    <span><a href="http://quickbis.com/">PMS</a> © 2021 Quintec Business Solutions Pvt. Ltd.</span>
    <span title="New Leave Request/Approved/Rejected" style="float: right;">
        <img src="../../../../assets/Images/chat.ico">
        <span class="messagepopup">{{this.commonService.nodificationcount}}</span>
    </span>
</footer>

